<template>
<div class="mr-2">
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <a class="nav-link mr20">
        <img :src="globals.avatarSrc" class="rounded-circle mr-2" width="40" height="40" alt="" title="" />
        Hello,
        <span>{{globals.username}}</span></a>
    </template>
    <b-dropdown-item v-on:click.prevent="editMyData()"><a href="">
        <!-- icon icon="globe"></icon --> {{$t('EDITDATA')}}
      </a></b-dropdown-item>
    <b-dropdown-item>
      <a target="_blank" href="/">
        <!-- icon icon="globe"></icon -->
        {{$t('OPENSITEINNEWWINDOW')}}
      </a>
    </b-dropdown-item>
    <b-dropdown-item v-on:click.prevent="logout"><a href="">
        <!-- icon icon="globe"></icon --> {{$t('LOGOUT')}}
      </a></b-dropdown-item>
  </b-nav-item-dropdown>
  <b-modal ref="formmodal" :title="$t('ACCOUNTDETAILS')" ok-title="submit" hide-footer no-close-on-backdrop>
    <div class="d-block">
      <div role="group" class="b-form-group form-group">
        <div class="form-row mb-lg">
          <div class="col-sm-12">
            <b-form-fieldset v-bind:label="$t('NEWPASSWORD')">
              <inputvalidation :formerror="formError" name="password">
                <b-form-input type="password" v-model="formData.password" v-bind:placeholder="$t('PASSWORD')"></b-form-input>
              </inputvalidation>
            </b-form-fieldset>
          </div>
        </div>
        <div class="form-row mb-lg">
          <div class="col-sm-12">
            <b-form-fieldset v-bind:label="$t('AVATAR')">
              <fileupload v-model="formData.imageFile" :chooseLabel="$t('SELECTFILE')" />
            </b-form-fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="saveRow(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>
<script>
import
{
  mapGetters,
  mapActions
}
from 'vuex'
import Api from '@/api/admin/Users'

export default
{
  name: 'header-dropdown-accnt',
  data: function()
  {
    return {
      formError:
      {},
      formData:
      {
        userId: null,
        password: ''
      }
    }
  },
  methods:
  {
    ...mapActions([
      'logout',
      'getGlobals'
    ]),
    editMyData()
    {
      var me = this;
      me.formData.userId = me.globals.userId;

      this.$refs.formmodal.show()
    },
    saveRow: function(item)
    {
      var me = this;

      if (typeof item.userId != 'undefined')
      {
        item.id = item.userId;
        delete(item.userId);
      }

      Api.save(item, function(val)
      {
        if (val.error)
        {
          me.$notify.notice(val);
          me.formError = val;
        }
        else
        {
          me.$notify.notice(val);
          me.formError = {};
          me.hideModal();
          me.getGlobals();
        }
      })
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
